import { useStatsigClient } from '@statsig/react-bindings';
import { dynamicConfigNames, gateNames } from '../constants/statsig';

export function useOnboardingVideoConfig() {
  const { client } = useStatsigClient();
  const config = client.getDynamicConfig(dynamicConfigNames.educationalVideos);

  const baseUrl = config.get(gateNames.onboardingVideoURL, '');
  const videoUrl = baseUrl ? `${baseUrl}?rel=0&autoplay=0` : '';

  return { videoUrl };
}
